import { render, staticRenderFns } from "./ElementVcamIframe.vue?vue&type=template&id=941bcafc&scoped=true&"
import script from "./ElementVcamIframe.vue?vue&type=script&lang=js&"
export * from "./ElementVcamIframe.vue?vue&type=script&lang=js&"
import style0 from "./ElementVcamIframe.vue?vue&type=style&index=0&id=941bcafc&lang=css&v-html=true&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941bcafc",
  null
  
)

export default component.exports